// extracted by mini-css-extract-plugin
export default {"title":"Style_title__sfeFu","w100":"Style_w100__fMqAd","wrapper":"Style_wrapper__5YBV-"};